<template>
  <div class="company-ticket-list">
    <div class="ticket-list-head"></div>
    <div class="ticket-list-body">
      <div class="ticket-list-body-h">
        <h3>授权管理</h3>
        <bcc-button v-if='isManager' :disabled='$store.state.companyInfo.state !== 1' @click="handleCreateAuth" size='large' type="primary">发起授权</bcc-button>
      </div>
      <bcc-tabs @on-change="tabsChange">
        <bcc-tab v-if='isManager' label="授权账号管理" id="account"></bcc-tab>
        <bcc-tab label="授权消息管理" id="message"></bcc-tab>
      </bcc-tabs>
      <account ref='account' v-if='isManager && curTab === "account"' />
      <message ref='messge' v-if='curTab === "message"' />
    </div>
    <CreateAuthDialog @refreshData='refreshData' ref='dialog' />
  </div>
</template>
<script>
import account from './account'
import message from './message'
import CreateAuthDialog from './createAuthDialog'
export default {
  data () {
    return {
      curTab: ''
    }
  },
  components: {
    account,
    CreateAuthDialog,
    message
  },
  computed: {
    isManager () {
      if (!this.$store.state.arcUserInfo) {
        return false
      }
      return [1,20].includes(this.$store.state.arcUserInfo.level)
    },
  },
  created () {
    this.$LogReport.sendCustomEvent('openplat_authorizemanage_page_load')
    this.curTab = this.isManager ? 'account' : 'message'    
  },
  methods: {
    refreshData () {
      this.$refs[this.curTab].renderList('init')
    },
    handleCreateAuth () {
      this.$refs.dialog.show = true
    },
    tabsChange (val) {
      this.curTab = val
    },
  }
}
</script>

<style scoped lang="scss">
.company-ticket-list {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
}

.ticket-list-head {
  padding: 16px 0 16px 26px;
}

.ticket-list-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;

  .ticket-list-body-h {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-bottom: 1px solid #E7E7E7;
    height: 64px;
    justify-content: space-between;

    h3 {
      font-size: 24px;
      color: #212121;
    }
  }

  .ticket-list-body-b {
    padding: 24px;

    .ticket-list-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;

      .txt {
        font-size: 14px;
        margin-right: 20px;
      }

      .ps-select {
        margin-right: 40px;
      }
    }
  }
}

.tabs {
  margin-left: 25px;
}
</style>
